import { render, staticRenderFns } from "./FrameThumbnails.vue?vue&type=template&id=3888cd6a"
import script from "./FrameThumbnails.vue?vue&type=script&lang=js"
export * from "./FrameThumbnails.vue?vue&type=script&lang=js"
import style0 from "./FrameThumbnails.vue?vue&type=style&index=0&id=3888cd6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports